import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsJsonConverterDate } from '@pit/core';
import { DeviceState, IDtoDevice } from '../interfaces/dto.device.interface';
import { IDtoDepot } from '../interfaces/dto.depot.interface';
import { DtoDepot } from './dto.depot';
import { IDtoMandator } from '../interfaces/dto.mandator.interface';
import { DtoMandator } from './dto.mandator';
import { IDtoUser } from '../interfaces/dto.user.interface';
import { DtoUser } from './dto.user';
import { IDtoAppVersion } from '../interfaces/dto.app.version.interface';
import { DtoAppVersion } from './dto.app.version';

// @dynamic
@JsonObject('DtoDevice')
export class DtoDevice extends ModelEntity implements IDtoDevice {

    constructor(initValues: Partial<IDtoDevice> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('account', String, true)
    public account?: string = null;

    @JsonProperty('accountMail', String, true)
    public accountMail?: string = null;

    @JsonProperty('imeiNumber', String, true)
    public imeiNumber?: string = null;

    @JsonProperty('phoneNumber', String, true)
    public phoneNumber?: string = null;

    @JsonProperty('simPIN', String, true)
    public simPIN?: string = null;

    @JsonProperty('simPUK', String, true)
    public simPUK?: string = null;

    @JsonProperty('deviceId', String, true)
    public deviceId?: string = null;

    @JsonProperty('deviceState', Number, true)
    public deviceState?: DeviceState = DeviceState.Unregistered;

    @JsonProperty('manufacturer', String, true)
    public manufacturer?: string = null;

    @JsonProperty('model', String, true)
    public model?: string = null;

    @JsonProperty('name', String, true)
    public name?: string = null;

    @JsonProperty('platform', String, true)
    public platform?: string = null;

    @JsonProperty('operatingSystem', String, true)
    public operatingSystem?: string = null;

    @JsonProperty('osVersion', String, true)
    public osVersion?: string = null;

    @JsonProperty('serialNumber', String, true)
    public serialNumber?: string = null;

    @JsonProperty('connectionId', String, true)
    public connectionId?: string = null;

    @JsonProperty('fcmToken', String, true)
    public fcmToken?: string = null;

    @JsonProperty('isOnline', Boolean, true)
    public isOnline?: boolean = false;

    @JsonProperty('lastSync', UtilsJsonConverterDate, true)
    public lastSync?: Date = null;

    @JsonProperty('coordsLpositionLatitudeatitude', Number, true)
    public positionLatitude?: number = null;

    @JsonProperty('positionLongitude', Number, true)
    public positionLongitude?: number = null;

    @JsonProperty('positionTimestamp', UtilsJsonConverterDate, true)
    public positionTimestamp?: Date = null;

    @JsonProperty('batteryIsCharging', Boolean, true)
    public batteryIsCharging?: boolean = null;

    @JsonProperty('batteryLevel', Number, true)
    public batteryLevel?: number = null;

    @JsonProperty('batteryStatusTimestamp', UtilsJsonConverterDate, true)
    public batteryStatusTimestamp?: Date = null;

    @JsonProperty('appVersion', DtoAppVersion, true)
    public appVersion?: IDtoAppVersion = null;

    @JsonProperty('depot', DtoDepot, true)
    public depot?: IDtoDepot = null;

    @JsonProperty('mandator', DtoMandator, true)
    public mandator?: IDtoMandator = null;

    @JsonProperty('user', DtoUser, true)
    public user?: IDtoUser = null;

    public get deviceStateDescription(): string {
        let result: string = null;

        switch (this.deviceState) {
            case DeviceState.Unregistered: {
                result = 'Unregistriert';
                break;
            }
            case DeviceState.Registered: {
                result = 'Registriert';
                break;
            }
            case DeviceState.Disabled: {
                result = 'Deaktiviert';
                break;
            }
            case DeviceState.Active: {
                result = 'Aktiv';
                break;
            }
        }

        return result;
    }
}
